import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

// LIFFの型定義
interface LiffProfile {
  userId: string;
  displayName: string;
  pictureUrl?: string;
  statusMessage?: string;
}

interface Liff {
  init(config: { liffId: string }): Promise<void>;
  isLoggedIn(): boolean;
  login(): void;
  getProfile(): Promise<LiffProfile>;
  getIDToken(): string | null;
  isInClient(): boolean;
}

declare var liff: Liff;

@Component({
  selector: 'app-line-login',
  templateUrl: './line-login.component.html',
  styleUrls: ['./line-login.component.scss']
})
export class LineLoginComponent implements OnInit {
  email: string = '';
  password: string = '';
  lineUserId: string = '';
  showCompletionMessage: boolean = false;
  isLoading: boolean = true;
  errorMessage: string = '';
  isLineClient: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient
  ) {}

  async ngOnInit() {
    try {
      // LIFF初期化
      console.log('LIFF初期化を開始します...');
      
      await liff.init({ liffId: environment.liffLoginId });
      console.log('LIFF初期化完了');

      // LINE内ブラウザかどうかを確認
      this.isLineClient = liff.isInClient();
      console.log('LINE内ブラウザ:', this.isLineClient);

      // ログイン状態とLINE IDを確認
      if (liff.isLoggedIn()) {
        // ログイン済みの場合、LINE IDを取得
        const profile = await liff.getProfile();
        this.lineUserId = profile.userId;
        console.log('LINE ID取得完了:', this.lineUserId);
        this.isLoading = false;
      } else {
        // 未ログインの場合、ログイン処理を実行
        console.log('LINEログインを開始します');
        liff.login();
      }
    } catch (err) {
      console.error('LIFFエラー詳細:', err);
      this.errorMessage = `エラーが発生しました: ${err.message || '不明なエラー'}`;
      this.isLoading = false;
    }
  }

  async linkLine(event?: Event) {
    if (!this.email || !this.password) {
      alert('メールアドレスとパスワードを入力してください');
      return;
    }

    try {
      // APIのURL情報をコンソールに出力
      const apiUrl = environment.apiUrl;
      console.log('LINE連携リクエスト送信:', {
        url: `${apiUrl}/api/v1/line/link`,
        lineUserId: this.lineUserId,
        isLineClient: this.isLineClient
      });

      // 認証ヘッダーを付けないようにするため、HttpClientを直接使用
      const response = await fetch(`${apiUrl}/api/v1/line/link`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: this.email,
          password: this.password,
          lineUserId: this.lineUserId
        })
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        console.error('サーバーエラー:', errorData);
        throw new Error(errorData.message || '認証エラー');
      }

      // 成功時のみ完了メッセージを表示
      this.showCompletionMessage = true;
    } catch (error) {
      // アラートを表示
      alert('LINE連携に失敗しました。メールアドレスとパスワードを確認してください。');
      
      // エラーメッセージを設定
      this.errorMessage = 'メールアドレスまたはパスワードが正しくありません';
      
      // パスワードのみをクリア
      this.password = '';
      
      // エラーをコンソールに出力
      console.error('LINE連携エラー:', error);
    }
  }

  goToHome() {
    this.router.navigate(['/']);
  }
} 